import React, { Component } from 'react'
import $ from 'jquery'
import { get, post, postWithHeaders, put } from "../../../server/actions";
import { required } from '../../../server/validationMethods'
import { BeatLoader } from 'react-spinners';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Button from 'react-validation/build/button';
import Phone from 'react-phone-number-input';
import PropTypes from "prop-types";
import NotificationSystem from 'react-notification-system';
import { _addNotification, _addNotificationError, numberOnly, getAccessLevelByModule, getModuleEnum } from "../../../server/util";
import { dial_code, ENV, mobileNoLength } from '../../../server/constants'
import _ from 'lodash';
let mealSchoolId = '';
function editUserNameFun() {
    $("#changeNameUserOne").hide();
    $("#changeNameUserTwo").show();
    $("#userLN").val($("#userSpanLN").text());
    $("#userFN").val($("#userSpanFN").text());
}

function editUNFun() {
    $("#changeUNOne").hide();
    $("#changeUNTwo").show();
    $("#userUN").val($("#userSpanUN").text());
}

function editPhoneFun() {
    $("#changePhoneOne").hide();
    $("#changePhoneTwo").show();
    $("#userPhone").val($("#userSpanPhone").text());
}

function changePWDFun() {
    $("#changePasswordSec").show();
}

function addSchoolInfo() {
    $("#schoolInfo").show();
}

class accountDetails extends Component {
    constructor() {
        super();
        this.state = {
            mobileLength: mobileNoLength(),
            userInfo: {},
            schoolInfo: {},
            mealSchoolInfo: {},
            loading: false,
            schoolLogo: '',
            contactPEmail: '',
            contactPName: '',
            contactPPhone: '',
            contactPAddress: '',
            principalName: '',
            principalEmail: '',
            principalPhone: '',
            principalAddress: '',
            benefitsPersonName : '',
            benefitsPersonEmail : '',
            benefitsPersonPhone : '',
            benefitsPersonAddress : '',
            fairHearingOfficialName: '',
            fairHearingOfficialPhone: '',
            fairHearingOfficialEmail: '',
            fairHearingOfficialAddress:'', 
            showPrincipalPan: false,
            "password": '',
            pin: ''
        }
        this.gotoStripeDashboard = this.gotoStripeDashboard.bind(this);
        this.checkPass = this.checkPass.bind(this);
    }
    onChange(e) {
        this.state.password = e.target.value;
    }
    changePINFun = () => {
        $('#pin').val('')
        $('#cpin').val('')
        $("#changePinSec").show();
        this.setState({ pin: '' });
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;

        const { action } = this.context.router.route.match.params;
        $(document).ready(function () {
            if ((action || '').toLowerCase() === 'show-contact') {
                addSchoolInfo();
            }
            else if (action !== undefined) {
                changePWDFun();
                $('html,body').animate({
                    scrollTop: $("#" + action).offset().top
                },
                    'fast');
                /* changePINFun()
                $('html,body').animate({
                        scrollTop: $("#" + action).offset().top
                    },
                    'fast'); */
            }

            var readURL = function (input) {
                if (input.files && input.files[0]) {
                    var reader = new FileReader();

                    reader.onload = function (e) {
                        $('.user-profile-pic').attr('src', e.target.result);
                        $('.user-profile-pic').css('display', 'block');
                    }

                    reader.readAsDataURL(input.files[0]);
                }
            }


            $(".user-file-upload").on('change', function () {
                readURL(this);
            });

            $(".user-upload-button").on('click', function () {

                $(".user-file-upload").click();
            });
            $("#userNameUpdate").click(function () {
                // $("#userSpanLN").text($("#userLN").val());
                // $("#userSpanFN").text($("#userFN").val());
                $("#changeNameUserOne").show();
                $("#changeNameUserTwo").hide();
            });

            $("#UNUpdate").click(function () {
                $("#userSpanUN").text($("#userUN").val());
                $("#changeUNOne").show();
                $("#changeUNTwo").hide();
            });

            $("#PhoneUpdate").click(function () {
                $("#userSpanPhone").text($("#userPhone").val());
                $("#changePhoneOne").show();
                $("#changePhoneTwo").hide();
            });

            $("#PwdUpdate").click(function () {
                $("#changePasswordSec").hide();
                document.getElementById('message').innerHTML = '';
                document.getElementById("pwdSubmit").disabled = true;
                document.getElementById('cpwd').value = '';
                document.getElementById('pwd').value = '';
                document.getElementById('opwd').value = '';
            });
            $("#PinUpdate").click(function () {
                $("#changePinSec").hide();
            });
            $("#schoolInfoCancel").click(function () {
                $("#schoolInfo").hide();
            });
            $("#pin").keyup(function () {
                $("#pin").val(this.value.match(/[0-9]*/));
            });
            $("#cpin").keyup(function () {
                $("#cpin").val(this.value.match(/[0-9]*/));
            });
        });
        this.validatePasswordStrength();

    }
    schoolInfo = (e) => {
        this.state.mealSchoolInfo[e.target.name] = e.target.value
        this.forceUpdate()

        //this.setState({mealSchoolInfo[e.target.name]: e.target.value});
    }
    onChangePin(e) {
        this.state.pin = e.target.value;
    }
    componentWillMount = () => {
        mealSchoolId = sessionStorage.getItem('SchoolId');
        this.setState({ loading: true })
        get('/mealSchools/' + mealSchoolId + '/school?access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            console.log('Got School data', data);
            let _userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'))
            _userInfo.mobileNo = (_userInfo.mobileNo || '').substr(-this.state.mobileLength);
            this.setState({
                schoolInfo: data,
                loading: false,
                userInfo: _userInfo
            }, () => {
                //this.state.userInfo.mobileNum = this.state.userInfo.mobileNo;
                console.log(this.state.userInfo)
            });

        })
            .catch(
                (error) => {
                    this.setState({
                        loading: false
                    })
                    console.log('Get Meal Menu response', error)
                }
            )
        this.setState({ loading: true })
        get('/mealSchools/' + mealSchoolId + '?access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            let _dataObj = data
            _dataObj.contactPPhone = (_dataObj.contactPPhone || '').substr(-this.state.mobileLength);
            _dataObj.fairHearingOfficialPhone = (_dataObj.fairHearingOfficialPhone || '').substr(-this.state.mobileLength);
            _dataObj.benefitsPersonPhone = (_dataObj.benefitsPersonPhone || '').substr(-this.state.mobileLength);
            _dataObj.principalPhone = (_dataObj.principalPhone || '').substr(-this.state.mobileLength);

            this.setState({
                schoolLogo: data.logoLink,
                loading: false,
                mealSchoolInfo: data
            }, () => {
            })


        })
            .catch(
                (error) => {
                    this.setState({ loading: false })
                    console.log('Get school logo response', error)
                }
            )
    }
    uploadLogo = (e) => {
        //alert(e.target.value)
        // /https://devapi2.mealmanage.com/mealManage/uploadMealSchoolLogo?mealSchoolId=100&loggedUser=pankaj@mealmanage.com&access_token=15a81e02-abe0-4324-9425-dab0996e9ad1
        this.setState({ loading: true })
        let fileInput = document.getElementById('logo').files[0];
        var data = new FormData();
        data.append('file', fileInput);
        post('/uploadMealSchoolLogo?mealSchoolId=' + mealSchoolId + '&loggedUser=' + sessionStorage.getItem('loggedUserName') + '&access_token=', data).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.text();
        }).then(data => {
            this.setState({ loading: false })
            console.log("Meal School Logo updated")
        }).catch(
            (error) => {
                this.setState({ loading: false })
                console.log('Cannot load image', error)
            }
        );
    }
    changePassword = (event) => {
        event.preventDefault();
        this.setState({ loading: true })
        // https://devapi2.mealmanage.com/mealManage/updatePassword?access_token=845c5ef7-3693-4c69-8d59-89d49fffe097
        let data = {}
        data.username = sessionStorage.getItem('loggedUserName')
        data.password = document.getElementById("pwd").value;
        data.oldPassword = document.getElementById("opwd").value;
        let headers = {
            'Content-Type': 'application/json'
        }
        postWithHeaders('/updatePassword?access_token=', JSON.stringify(data), headers).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.setState({ loading: false })
            _addNotification("Password changed succesfully.", this)
            $("#changePasswordSec").hide();
        }).catch(
            (error) => {
                this.setState({ loading: false })
                _addNotificationError("Cannot update password.", this)

                console.log('Cannot update password ', error)
            }
        );
    }
    handlePinSubmit = (event) => {
        event.preventDefault();
        this.setState({ loading: true });
        let pin = document.getElementById("pin").value;
        let _userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'))
        let userID = _userInfo.userId
        /* get(`/mealSchools/search/updatePin?username=${userName}&pin=${pin}&access_token=`) */
        put(`/${mealSchoolId}/${userID}/generateAdminPIN?pin=${pin}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        }).then(data => {
            this.state.userInfo.pin = pin
            sessionStorage.setItem('loggedInUserInfo', JSON.stringify(this.state.userInfo))
            this.setState({ userInfo: JSON.parse(sessionStorage.getItem('loggedInUserInfo')), loading: false });
            _addNotification('Successfully updated Pin.', this);
            $("#changePinSec").hide();

        })
            .catch(
                (error) => {
                    this.setState({ loading: false });
                    _addNotificationError('Could not update Pin.', this);
                }
            )

    }
    handleChange = (e) => {
        this.state.userInfo[e.target.name] = e.target.value;
        this.forceUpdate();
    }
    handleNameChange = (e) => {
        e.preventDefault()
        this.setState({ loading: true })
        // let formdata = this.state.mealSchoolInfo;
        let formdata = this.formatReqObject('name');
        // formdata.loggedUser = sessionStorage.getItem('loggedUserName');
        formdata.schoolUsers = [];
        let schoolUser = {};
        schoolUser.username = this.state.userInfo.username
        schoolUser.firstName = document.getElementById("userFN").value;
        schoolUser.lastName = document.getElementById("userLN").value;
        this.state.userInfo.firstName = schoolUser.firstName
        this.state.userInfo.firstName = schoolUser.lastName
        // formdata.schoolUsers.push(schoolUser);
        let headers = {
            'Content-Type': 'application/json'
        }
        postWithHeaders('/mealSchoolUpdate?mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&access_token=', JSON.stringify(formdata), headers).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.state.userInfo.firstName = schoolUser.firstName
            this.state.userInfo.lastName = schoolUser.lastName
            this.state.userInfo.isContactDetailsReq = false;
            sessionStorage.setItem('loggedInUserInfo', JSON.stringify(this.state.userInfo))
            this.setState({
                userInfo: JSON.parse(sessionStorage.getItem('loggedInUserInfo')), loading: false
            })
            _addNotification("Name updated successfully.", this)

            $("#changeNameUserOne").show();
            $("#changeNameUserTwo").hide();
        }).catch(
            (error) => {
                this.setState({ loading: false })
                _addNotificationError("Name could not update.", this)

                console.log('Cannot update name ', error)
            }
        );


    }

    isBlockFilled = (name, email, phone) => {
        const n = (name || '').trim();
        const e = (email || '').trim();
        const p = (phone || '').trim();

        if (n && e && p) return 'valid';
        if (n || e || p) return 'partial';
        return 'empty';
    };

    handleSchoolInfo = (e) => {
        e.preventDefault();
        this.setState({ loading: true })
        
        let checkContactPerson=false;
        let checkPrincipal=false;
        let checkBenefitsPerson=false;
        let checkFairHearingOfficial=false;

        if ((this.state.mealSchoolInfo.contactPName || '').trim() == '' || (this.state.mealSchoolInfo.contactPEmail || '').trim() == '' || (this.state.mealSchoolInfo.contactPPhone || '').trim() == ''){
            checkContactPerson=true;
        } 
        if ((this.state.mealSchoolInfo.principalName || '').trim() == '' || (this.state.mealSchoolInfo.principalEmail || '').trim() == '' || (this.state.mealSchoolInfo.principalPhone || '').trim() == ''){
            checkPrincipal=true;
        }
        if ((this.state.mealSchoolInfo.benefitsPersonName || '').trim() == '' || (this.state.mealSchoolInfo.benefitsPersonEmail || '').trim() == '' || (this.state.mealSchoolInfo.benefitsPersonPhone || '').trim() == ''){
            checkBenefitsPerson=true;
        } 
        if ((this.state.mealSchoolInfo.fairHearingOfficialName || '').trim() == '' || (this.state.mealSchoolInfo.fairHearingOfficialEmail || '').trim() == '' || (this.state.mealSchoolInfo.fairHearingOfficialPhone || '').trim() == '') {
            checkFairHearingOfficial=true;
        }

        if (checkContactPerson && checkPrincipal && checkBenefitsPerson && checkFairHearingOfficial) {
            this.setState({ loading: false })
            _addNotificationError("Please fill the required fields.", this);
            return false;
        }

        if (((this.state.mealSchoolInfo.contactPName || '').trim() != '' && ((this.state.mealSchoolInfo.contactPEmail || '').trim() == '' || (this.state.mealSchoolInfo.contactPPhone || '').trim() == '')) || ((this.state.mealSchoolInfo.contactPEmail || '').trim() != '' && ((this.state.mealSchoolInfo.contactPName || '').trim() == '' || (this.state.mealSchoolInfo.contactPPhone || '').trim() == '')) || ((this.state.mealSchoolInfo.contactPPhone || '').trim() != '' && ((this.state.mealSchoolInfo.contactPName || '').trim() == '' || (this.state.mealSchoolInfo.contactPEmail || '').trim() == ''))){
            this.setState({ loading: false })
            _addNotificationError("Please fill the required fields.", this);
            return false;
        } 

        if (((this.state.mealSchoolInfo.principalName || '').trim() != '' && ((this.state.mealSchoolInfo.principalEmail || '').trim() == '' || (this.state.mealSchoolInfo.principalPhone || '').trim() == '')) || ((this.state.mealSchoolInfo.principalEmail || '').trim() != '' && ((this.state.mealSchoolInfo.principalName || '').trim() == '' || (this.state.mealSchoolInfo.principalPhone || '').trim() == '')) || ((this.state.mealSchoolInfo.principalPhone || '').trim() != '' && ((this.state.mealSchoolInfo.principalName || '').trim() == '' || (this.state.mealSchoolInfo.principalEmail || '').trim() == ''))){
            this.setState({ loading: false })
            _addNotificationError("Please fill the required fields.", this);
            return false;
        }

        if (((this.state.mealSchoolInfo.benefitsPersonName || '').trim() != '' && ((this.state.mealSchoolInfo.benefitsPersonEmail || '').trim() == '' || (this.state.mealSchoolInfo.benefitsPersonPhone || '').trim() == '')) || ((this.state.mealSchoolInfo.benefitsPersonEmail || '').trim() != '' && ((this.state.mealSchoolInfo.benefitsPersonName || '').trim() == '' || (this.state.mealSchoolInfo.benefitsPersonPhone || '').trim() == '')) || ((this.state.mealSchoolInfo.benefitsPersonPhone || '').trim() != '' && ((this.state.mealSchoolInfo.benefitsPersonName || '').trim() == '' || (this.state.mealSchoolInfo.benefitsPersonEmail || '').trim() == ''))){
            this.setState({ loading: false })
            _addNotificationError("Please fill the required fields.", this);
            return false;
        }

        if (((this.state.mealSchoolInfo.fairHearingOfficialName || '').trim() != '' && ((this.state.mealSchoolInfo.fairHearingOfficialEmail || '').trim() == '' || (this.state.mealSchoolInfo.fairHearingOfficialPhone || '').trim() == '')) || ((this.state.mealSchoolInfo.fairHearingOfficialEmail || '').trim() != '' && ((this.state.mealSchoolInfo.fairHearingOfficialName || '').trim() == '' || (this.state.mealSchoolInfo.fairHearingOfficialPhone || '').trim() == '')) || ((this.state.mealSchoolInfo.fairHearingOfficialPhone || '').trim() != '' && ((this.state.mealSchoolInfo.fairHearingOfficialName || '').trim() == '' || (this.state.mealSchoolInfo.fairHearingOfficialEmail || '').trim() == ''))){
            this.setState({ loading: false })
            _addNotificationError("Please fill the required fields.", this);
            return false;
        }

        if (this.state.mealSchoolInfo.contactPPhone.length < this.state.mobileLength && this.state.mealSchoolInfo.principalPhone.length < this.state.mobileLength && this.state.mealSchoolInfo.benefitsPersonPhone.length < this.state.mobileLength && this.state.mealSchoolInfo.fairHearingOfficialPhone.length < this.state.mobileLength ) {
            this.setState({ loading: false })
            _addNotificationError("Please provide valid mobile no's.", this)
            return false;
        }
        let headers = {
            'Content-Type': 'application/json'
        }
        let _mealSchoolInfo = this.formatReqObject('info');//JSON.parse(JSON.stringify(this.state.mealSchoolInfo)) ;
        //_mealSchoolInfo.contactPPhone=(_mealSchoolInfo.contactPPhone.length>0?(dial_code()+_mealSchoolInfo.contactPPhone):'')
        //_mealSchoolInfo.principalPhone=(_mealSchoolInfo.principalPhone.length>0?(dial_code()+_mealSchoolInfo.principalPhone):'')
        _mealSchoolInfo.schoolUsers = [];

        postWithHeaders('/mealSchoolUpdate?mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&access_token=', JSON.stringify(_mealSchoolInfo), headers).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.setState({ loading: false })
            $("#schoolInfo").hide();
            _addNotification("Information updated sucessfully.", this)

        }).catch(
            (error) => {
                this.setState({ loading: false })
                _addNotificationError("Information could not update.", this)
                console.log('Information dint update ', error)
            }
        );

    }

    checkPass = () => {
        if (document.getElementById('opwd').value === '') {
            document.getElementById('message').style.color = 'red';
            document.getElementById('message').innerHTML = 'Please Enter Old Password';
            document.getElementById("pwdSubmit").disabled = false;
            return false;

        }
        if (document.getElementById('pwd').value ===
            document.getElementById('cpwd').value) {
            if (this.checkStrength()) {
                document.getElementById('message').innerHTML = '';
                document.getElementById("pwdSubmit").disabled = false;
            } else {
                document.getElementById('message').innerHTML = '';
                document.getElementById("pwdSubmit").disabled = true;
            }
        } else {
            document.getElementById('message').style.color = 'red';
            document.getElementById('message').innerHTML = 'Passwords do not match';
            document.getElementById("pwdSubmit").disabled = true;
        }
        if (document.getElementById('pwd').value === '') {
            document.getElementById('message').innerHTML = '';

        }
    }
    checkPin = () => {
        if (document.getElementById('pin').value ===
            document.getElementById('cpin').value) {
            document.getElementById('pinMessage').innerHTML = '';
            document.getElementById("submitPin").disabled = false;
        } else {
            document.getElementById('pinMessage').style.color = 'red';
            document.getElementById('pinMessage').innerHTML = 'Pins do not match';
            document.getElementById("submitPin").disabled = true;
        }
        if (document.getElementById('pin').value === '') {
            document.getElementById('pinMessage').innerHTML = '';

        }
    }
    handlePhoneChange = (e, id, stateObject) => {
        //let input = document.getElementById(id);
        // if (input) {
        // input.oninput = function (event) {
        //     event.target.setCustomValidity('')
        // }
        //  input.oninvalid = function (event) {
        //      event.target.setCustomValidity('Please enter a valid mobile number');
        //  }
        // }
        // if (value) {
        stateObject ? this.state[stateObject][id] = e.target.value : this.state[id] = e.target.value
        //alert(this.state.userInfo.mobileNo)
        this.forceUpdate();
        // }
    }
    gotoStripeDashboard = () => {
        this.setState({ loading: true })
        get('/stripeAcAccessLink?accountId=' + this.state.mealSchoolInfo.stripeAccountId + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            console.log('account Url:', data)
            window.open(data.stripeAcLink, '_blank');
            this.setState({ loading: false })

        }).catch(
            (error) => {
                this.setState({ loading: false })
                console.log('Get SchoolDistricts response', error)
            }
        );
    }
    formatReqObject = (type) => {
        let formData = JSON.parse(JSON.stringify(this.state.mealSchoolInfo));
        const idx = formData.schoolUsers.findIndex(usr => {
            return usr.username === sessionStorage.getItem('loggedUserName');
        })
        if (idx >= 0) {
            if (type === 'name') {
                formData.schoolUsers[idx].firstName = document.getElementById("userFN").value;
                formData.schoolUsers[idx].lastName = document.getElementById("userLN").value;
            }
            if (type === 'phone') {
                formData.schoolUsers[idx].mobileNo = this.state.userInfo.mobileNo.length > 0 ? (dial_code() + this.state.userInfo.mobileNo) : '';
            }
        }
        if (type === 'info') {
            formData.contactPPhone = (formData.contactPPhone.length > 0 ? (dial_code() + formData.contactPPhone) : '')
            formData.principalPhone = (formData.principalPhone.length > 0 ? (dial_code() + formData.principalPhone) : '')
            formData.benefitsPersonPhone = (formData.benefitsPersonPhone.length > 0 ? (dial_code() + formData.benefitsPersonPhone) : '')
            formData.fairHearingOfficialPhone = (formData.fairHearingOfficialPhone.length > 0 ? (dial_code() + formData.fairHearingOfficialPhone) : '')
        }
        if (formData.paymentGateways.length > 0) {
            const gateWayObj = formData.paymentGateways[0]
            const gateWayId = gateWayObj._links['paymentGateway'].href.split('/').pop();
            formData.paymentGateways = [{
                "paymentGateway": { "id": gateWayId },
                "formValues": gateWayObj.formValues
            }];
        }
        /* const users=this.state.userInfo;
        let allUsers=this.state.allUsers;
        const selectedTier=this.state.tierInfo.find(tier=>{
            return tier.isSelected===true;
        })
        
        formData.loggedUser = sessionStorage.getItem("loggedInUserInfo");
        formData.countryCode=formData.countryCode;
        formData.catererId=formData.catererId;
        formData.tierName=selectedTier.tierName;
        formData['paymentGateways']=[];
        const moduleAccess={};
        selectedTier.moduleInfos.map(mod=>{
            moduleAccess[mod.moduleName]=mod.defOption;
        });
        if(this.checkPaymentSelected()){
            formData['isPaymentEnabled']=true;
            const selectedGateway=this.state.gatewayOptions.find((itm)=>{
                return itm.select===true
            })
            if(selectedGateway){
                formData['paymentGateways'].push({
                    "paymentGateway":{"id":selectedGateway.id},
                    "formValues":selectedGateway.formValues
                });
            }else{
                formData['isPaymentEnabled']=false;
            }
        }else{
            formData['isPaymentEnabled']=false;
        }
        if((formData.mealSchoolId||0) === 0){
            formData.school="/mealManage/schools/"+formData.id;
            users[0]['isPrimaryUser']=true;
            users[0]['mobileNo']=users[0].code+''+users[0].phone;
            users[0]['role']='ROLE_ADMIN';
            users[0]['isActive']=true;
            users[0]['isPaymentRegister']=false;
            users[0]['isUnsubscribeGenNotif']=users[0].isUnsubscribeGenNotif||false;
            if(formData['isPaymentEnabled']===true){
                users[0]['isPaymentRegister']= true;
            }
        }else{
            if(formData['isPaymentEnabled']===true){               
                if(users.length<=1){
                    users.forEach((usr,i)=>{
                        users[i]['mobileNo']=usr.code+''+usr.phone;
                        users[i]['isPaymentRegister']=true;
                    });
                }else{
                    let res= users.some(usr=>{
                        return usr.isPaymentRegister
                    });
                    if(res!== true){
                        this.setState({selectEmailModal:true});
                        return false;
                    }
                }    
                users.forEach((usr,i)=>{
                    users[i]['mobileNo']=usr.code+''+usr.phone;
                })
            }else{
                users.forEach((usr,i)=>{
                    users[i]['mobileNo']=usr.code+''+usr.phone;
                    users[i]['isPaymentRegister']=false;
                });
            }               
        }
        if(allUsers.length>0){
            const groupbyUsers=groupBy(users,'displayRecId');
            allUsers.forEach((usr,i)=>{
                if(usr.isPrimaryUser){
                    allUsers[i]=groupbyUsers[usr.displayRecId][0];
                }
            });
        }else{
            allUsers=users;
        }
        formData.schoolUsers = allUsers;
        formData.moduleAccess=moduleAccess; */

        return formData;
    }

    handlePhoneUpdate = (e) => {
        e.preventDefault();
        this.setState({ loading: true })
        let formdata = this.formatReqObject('phone');
        //formdata.loggedUser = sessionStorage.getItem('loggedUserName');
        formdata.schoolUsers = [];
        // let schoolUser = {};
        //schoolUser.username = this.state.userInfo.username
        //schoolUser.mobileNo =this.state.userInfo.mobileNo.length>0?(dial_code()+this.state.userInfo.mobileNo):'' ;
        // formdata.schoolUsers.push(schoolUser);
        let headers = {
            'Content-Type': 'application/json'
        }
        //alert(JSON.stringify(formdata,null,2));
        postWithHeaders('/mealSchoolUpdate?mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&access_token=', JSON.stringify(formdata), headers).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            sessionStorage.setItem('loggedInUserInfo', JSON.stringify(this.state.userInfo))
            this.setState({
                userInfo: JSON.parse(sessionStorage.getItem('loggedInUserInfo')), loading: false
            })
            _addNotification("Phone number updated succesfully.", this)
            $("#changePhoneOne").show();
            $("#changePhoneTwo").hide();
        }).catch(
            (error) => {
                this.setState({ loading: false })
                _addNotificationError("Phone number could not update.", this)
                console.log('Cannot update phone ', error)
            }
        );
    }
    checkStrength = () => {
        let password = document.getElementById('pwd').value;
        let isValid = true;

        //If password contains both lower and uppercase characters
        if (!password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) {
            isValid = false;
        }
        //If it has numbers and characters
        if (!password.match(/([0-9])/)) {
            isValid = false;
        }
        //If it has one special character
        if (!password.match(/([!,%,&,@,$,^,*,?,_,~])/)) {
            isValid = false;
        }
        //If password is greater than 7
        if (!password.length > 7) {
            isValid = false;
        }
        return isValid;
    }

    validatePasswordStrength = () => {
        //let state = false;
        let password = document.getElementById("pwd");
        let passwordStrength = document.getElementById("password-strength");
        let lowUpperCase = document.querySelector(".low-upper-case i");
        let number = document.querySelector(".one-number i");
        let specialChar = document.querySelector(".one-special-char i");
        let eightChar = document.querySelector(".eight-character i");

        password.addEventListener("keyup", function () {
            let pass = document.getElementById("pwd").value;
            checkStrength(pass);
        });

        /* const toggle=()=>{
            if(state){
                document.getElementById("password").setAttribute("type","password");
                state = false;
            }else{
                document.getElementById("password").setAttribute("type","text")
                state = true;
            }
        } */

        /* const myFunction=(show)=>{
            show.classList.toggle("fa-eye-slash");
        } */

        const checkStrength = (password) => {
            let strength = 0;

            //If password contains both lower and uppercase characters
            if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) {
                strength += 1;
                lowUpperCase.classList.remove('fa-circle');
                lowUpperCase.classList.add('fa-check');
            } else {
                lowUpperCase.classList.add('fa-circle');
                lowUpperCase.classList.remove('fa-check');
            }
            //If it has numbers and characters
            if (password.match(/([0-9])/)) {
                strength += 1;
                number.classList.remove('fa-circle');
                number.classList.add('fa-check');
            } else {
                number.classList.add('fa-circle');
                number.classList.remove('fa-check');
            }
            //If it has one special character
            if (password.match(/([!,%,&,@,$,^,*,?,_,~])/)) {
                strength += 1;
                specialChar.classList.remove('fa-circle');
                specialChar.classList.add('fa-check');
            } else {
                specialChar.classList.add('fa-circle');
                specialChar.classList.remove('fa-check');
            }
            //If password is greater than 7
            if (password.length > 7) {
                strength += 1;
                eightChar.classList.remove('fa-circle');
                eightChar.classList.add('fa-check');
            } else {
                eightChar.classList.add('fa-circle');
                eightChar.classList.remove('fa-check');
            }

            // If value is less than 2
            if ((password || '').length == 0) {
                passwordStrength.classList.remove('progress-bar-warning');
                passwordStrength.classList.remove('progress-bar-success');
                passwordStrength.classList.remove('progress-bar-danger');
                passwordStrength.style = 'width: 0%';

            } else if (strength < 2) {
                passwordStrength.classList.remove('progress-bar-warning');
                passwordStrength.classList.remove('progress-bar-success');
                passwordStrength.classList.add('progress-bar-danger');
                passwordStrength.style = 'width: 10%';
            } else if (strength == 3) {
                passwordStrength.classList.remove('progress-bar-success');
                passwordStrength.classList.remove('progress-bar-danger');
                passwordStrength.classList.add('progress-bar-warning');
                passwordStrength.style = 'width: 60%';
            } else if (strength == 4) {
                passwordStrength.classList.remove('progress-bar-warning');
                passwordStrength.classList.remove('progress-bar-danger');
                passwordStrength.classList.add('progress-bar-success');
                passwordStrength.style = 'width: 100%';
            }
        }
    }
    render() {
        const modEnum = getModuleEnum();
        return (
            <section className=" full-width clearfix">
                <div className='sweet-loading'
                    style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <NotificationSystem ref="notificationSystem" />

                <div className="container">
                    <div className="sectionTitle user-sectionTitle">
                        <h2>Account Details</h2>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-sm-12 col-xs-12">
                            <div className="panel panel-primary">
                                <div className="panel-heading text-center"><h3 className="panel-title">School
                                    Details</h3></div>

                                <div className="panel-body account-details-panel-body">
                                    <div className="col-md-5 small-12 medium-2 large-2 columns user-box-columns">
                                        <div className="user-circle">
                                            <img className="user-profile-pic"
                                                src={this.state.schoolLogo} />

                                        </div>
                                        <div className="user-p-image">
                                            <i className="fa fa-camera user-upload-button" data-toggle="tooltip"
                                                title="Upload Image" data-placement="right"></i>
                                            <input className="user-file-upload" type="file" id="logo"
                                                onChange={(e) => this.uploadLogo(e)} accept="image/*" />
                                        </div>

                                    </div>
                                    <div className="col-md-7 col-sm-12 col-xs-12 user-personal-info">
                                        <p>{this.state.schoolInfo.schoolName}</p>
                                        <p>Address: {this.state.schoolInfo.schoolAddress}</p>
                                        <p>{this.state.schoolInfo.state}-{this.state.schoolInfo.cityStateZip}</p>
                                        <div className="row">
                                            <div className="col-md-12 col-sm-12 col-xs-12 user-personal-info">
                                                <button type="button"
                                                    className="btn-social btn-twitter-link userChangePWD"
                                                    onClick={addSchoolInfo}>
                                                    <span>School Food Service Director & Principal/Fair Hearing Official</span></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="form-group clearfix user-form-fieldset" id="schoolInfo"
                                        style={{ display: 'none' }}>
                                        <fieldset className="user-fieldset">
                                            <Form 
                                            ref={c => { this.fomContact = c }} 
                                            onSubmit={(e) => {
                                                this.fomContact.validateAll();
                                                this.handleSchoolInfo(e)
                                            }} noValidate>
                                                <legend>School Food Service Director</legend>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">Name:*</label>
                                                    <div className="col-md-7">
                                                        <Input type="text" className="form-control"
                                                            name="contactPName" id="contactPName"
                                                            value={this.state.mealSchoolInfo.contactPName}
                                                            onChange={(e) => this.schoolInfo(e)}
                                                            placeholder="Name" autocomplete="off"
                                                            //validations={[required]}
                                                            //requiredmsg='Please enter food service manager name.'

                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">Email:*</label>
                                                    <div className="col-md-7">
                                                        <Input type="email" className="form-control"
                                                            name="contactPEmail" id="contactPEmail"
                                                            placeholder="Email"
                                                            value={this.state.mealSchoolInfo.contactPEmail}
                                                            onChange={(e) => this.schoolInfo(e)}
                                                            autocomplete="off"
                                                           // validations={[required, email]}
                                                            //requiredmsg='Please enter food service manager email.'
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">Phone:*</label>
                                                    <div className="col-md-7">
                                                        <Input type="text"
                                                            className="form-control"
                                                            id="contactPPhone"
                                                            name="contactPPhone"
                                                            placeholder={'Mobile Number'}
                                                            onChange={value => this.handlePhoneChange(value, 'contactPPhone', 'mealSchoolInfo')}
                                                            value={this.state.mealSchoolInfo.contactPPhone}
                                                            maxLength={this.state.mobileLength}
                                                            //validations={[required]}
                                                            //requiredmsg='Please enter food service manager phone number.'
                                                            onKeyPress={numberOnly} />

                                                        {/* <Phone
                                                            id="contactPPhone"
                                                            name="contactPPhone"
                                                            className="form-control"
                                                            value={this.state.mealSchoolInfo.contactPPhone}
                                                            countries={['US', 'CA']}
                                                            onChange={value => this.handlePhoneChange(value, 'contactPPhone', 'mealSchoolInfo')}
                                                            // todo: Need to use this {this.props.school.actionType === "NEW" ? 'US': ''} as we don't need default country for edit
                                                            placeholder={`Mobile Number`}
                                                            pattern="^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$"
                                                            maxlength="15"
                                                            smartCaret={false}
                                                            displayInitialValueAsLocalNumber={true}
                                                        /> */}
                                                        <span id='message1'></span>
                                                    </div>
                                                </div>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">Address:</label>
                                                    <div className="col-md-7">
                                                        <textarea id="contactPAddress" className="form-control"
                                                            rows="3" cols="60" name="contactPAddress" value={this.state.mealSchoolInfo.contactPAddress}
                                                            onChange={(e) => this.schoolInfo(e)}>
                                                        </textarea>
                                                        <span id='message2'></span>
                                                    </div>
                                                </div>
                                                { getAccessLevelByModule(modEnum.LETM) ?   <div className="clearfix">
                                                       <legend>Meal Eligibility Contact</legend>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">Name:*</label>
                                                    <div className="col-md-7">
                                                        <Input type="text" className="form-control"
                                                            name="benefitsPersonName" id="benefitsPersonName"
                                                            value={this.state.mealSchoolInfo.benefitsPersonName}
                                                            onChange={(e) => this.schoolInfo(e)}
                                                            placeholder="Name" autocomplete="off"
                                                            //validations={[required]}
                                                            //requiredmsg='Please enter Eligibility Contact name.'

                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">Email:*</label>
                                                    <div className="col-md-7">
                                                        <Input type="email" className="form-control"
                                                            name="benefitsPersonEmail" id="benefitsPersonEmail"
                                                            placeholder="Email"
                                                            value={this.state.mealSchoolInfo.benefitsPersonEmail}
                                                            onChange={(e) => this.schoolInfo(e)}
                                                            autocomplete="off"
                                                            //validations={[required, email]}
                                                            //requiredmsg='Please enter Eligibility Contact email.'
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">Phone:*</label>
                                                    <div className="col-md-7">
                                                        <Input type="text"
                                                            className="form-control"
                                                            id="benefitsPersonPhone"
                                                            name="benefitsPersonPhone"
                                                            placeholder={'Mobile Number'}
                                                            onChange={value => this.handlePhoneChange(value, 'benefitsPersonPhone', 'mealSchoolInfo')}
                                                            value={this.state.mealSchoolInfo.benefitsPersonPhone}
                                                            maxLength={this.state.mobileLength}
                                                            //validations={[required]}
                                                            //requiredmsg='Please enter Eligibility Contact phone number.'
                                                            onKeyPress={numberOnly} />

                                                        {/* <Phone
                                                            id="contactPPhone"
                                                            name="contactPPhone"
                                                            className="form-control"
                                                            value={this.state.mealSchoolInfo.contactPPhone}
                                                            countries={['US', 'CA']}
                                                            onChange={value => this.handlePhoneChange(value, 'contactPPhone', 'mealSchoolInfo')}
                                                            // todo: Need to use this {this.props.school.actionType === "NEW" ? 'US': ''} as we don't need default country for edit
                                                            placeholder={`Mobile Number`}
                                                            pattern="^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$"
                                                            maxlength="15"
                                                            smartCaret={false}
                                                            displayInitialValueAsLocalNumber={true}
                                                        /> */}
                                                        <span id='message1'></span>
                                                    </div>
                                                </div>
                                               <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">Address:</label>
                                                    <div className="col-md-7">
                                                        <textarea id="benefitsPersonAddress" className="form-control"
                                                            rows="3" cols="60" name="benefitsPersonAddress" value={this.state.mealSchoolInfo.benefitsPersonAddress}
                                                            onChange={(e) => this.schoolInfo(e)}>
                                                        </textarea>
                                                        <span id='message2'></span>
                                                    </div>
                                                </div>
                                                </div> : null }
                                                <div className="clearfix"></div>
                                                <div className="form-group clearfix user-form-fieldset">
                                                    <legend>Principal Contact</legend>
                                                    <div className="form-group clearfix">
                                                        <label className="col-md-4 control-label">Name:*</label>
                                                        <div className="col-md-7">
                                                            <Input type="text" className="form-control"
                                                                name="principalName" id="principalName"
                                                                value={this.state.mealSchoolInfo.principalName}
                                                                onChange={(e) => this.schoolInfo(e)}
                                                                placeholder="Name" autocomplete="off"
                                                                //requiredmsg='Please enter school principal name.'
                                                                //validations={[required]}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group clearfix">
                                                        <label className="col-md-4 control-label">Email:*</label>
                                                        <div className="col-md-7">
                                                            <Input type="email" className="form-control"
                                                                name="principalEmail" id="principalEmail"
                                                                placeholder="Email"
                                                                value={this.state.mealSchoolInfo.principalEmail}
                                                                onChange={(e) => this.schoolInfo(e)}
                                                                autocomplete="off"
                                                                //validations={[required, email]}
                                                                //requiredmsg='Please enter school principal email.'
                                                                required />
                                                        </div>
                                                    </div>
                                                    <div className="form-group clearfix">
                                                        <label className="col-md-4 control-label">Phone:*</label>
                                                        <div className="col-md-7">
                                                            <Input type="text"
                                                                className="form-control"
                                                                id="principalPhone"
                                                                name="principalPhone"
                                                                placeholder={'Mobile Number'}
                                                                onChange={e => this.handlePhoneChange(e, 'principalPhone', 'mealSchoolInfo')}
                                                                value={this.state.mealSchoolInfo.principalPhone}
                                                                maxLength={this.state.mobileLength}
                                                                //validations={[required]}
                                                                //requiredmsg='Please enter school principal phone number.'
                                                                onKeyPress={numberOnly} />
                                                            {/* <Phone
                                                                    id="principalPhone"
                                                                    name="principalPhone"
                                                                    className="form-control"
                                                                    value={this.state.mealSchoolInfo.principalPhone}
                                                                    countries={['US', 'CA']}
                                                                    onChange={value => this.handlePhoneChange(value, 'principalPhone', 'mealSchoolInfo')}
                                                                    // todo: Need to use this {this.props.school.actionType === "NEW" ? 'US': ''} as we don't need default country for edit
                                                                    placeholder={`Mobile Number`}
                                                                    pattern="^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$"
                                                                    maxlength="15"
                                                                    smartCaret={false}
                                                                    displayInitialValueAsLocalNumber={true}
                                                                /> */}
                                                            <span id='message3'></span>
                                                        </div>
                                                    </div>
                                                    <div className="form-group clearfix">
                                                        <label className="col-md-4 control-label">Address:</label>
                                                        <div className="col-md-7">
                                                            <textarea id="principalAddress" className="form-control"
                                                                rows="3" cols="60" name="principalAddress" value={this.state.mealSchoolInfo.principalAddress}
                                                                onChange={(e) => this.schoolInfo(e)}>
                                                            </textarea>
                                                            <span id='message4'></span>
                                                        </div>
                                                    </div>
                                                </div>
                                             { getAccessLevelByModule(modEnum.LETM) ?   <div className="form-group clearfix user-form-fieldset">
                                                    <legend>Fair Hearing Official</legend>
                                                       <div className="form-group clearfix">
                                                        <label className="col-md-4 control-label">Name:*</label>
                                                        <div className="col-md-7">
                                                            <Input type="text" className="form-control"
                                                                name="fairHearingOfficialName" id="fairHearingOfficialName"
                                                                value={this.state.mealSchoolInfo.fairHearingOfficialName}
                                                                onChange={(e) => this.schoolInfo(e)}
                                                                placeholder="Name" autocomplete="off"
                                                                //requiredmsg='Please enter Fair Hearing Official name.'
                                                                //validations={[required]}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group clearfix">
                                                        <label className="col-md-4 control-label">Email:*</label>
                                                        <div className="col-md-7">
                                                            <Input type="email" className="form-control"
                                                                name="fairHearingOfficialEmail" id="fairHearingOfficialEmail"
                                                                placeholder="Email"
                                                                value={this.state.mealSchoolInfo.fairHearingOfficialEmail}
                                                                onChange={(e) => this.schoolInfo(e)}
                                                                autocomplete="off"
                                                                //validations={[required, email]}
                                                                //requiredmsg='Please enter Fair Hearing Official email.'
                                                                required />
                                                        </div>
                                                    </div>
                                                    <div className="form-group clearfix">
                                                        <label className="col-md-4 control-label">Phone:*</label>
                                                        <div className="col-md-7">
                                                            <Input type="text"
                                                                className="form-control"
                                                                id="fairHearingOfficialPhone"
                                                                name="fairHearingOfficialPhone"
                                                                placeholder={'Mobile Number'}
                                                                onChange={e => this.handlePhoneChange(e, 'fairHearingOfficialPhone', 'mealSchoolInfo')}
                                                                value={this.state.mealSchoolInfo.fairHearingOfficialPhone}
                                                                maxLength={this.state.mobileLength}
                                                                //validations={[required]}
                                                                //requiredmsg='Please enter school Fair Hearing Official phone number.'
                                                                onKeyPress={numberOnly} />
                                                            {/* <Phone
                                                                    id="principalPhone"
                                                                    name="principalPhone"
                                                                    className="form-control"
                                                                    value={this.state.mealSchoolInfo.principalPhone}
                                                                    countries={['US', 'CA']}
                                                                    onChange={value => this.handlePhoneChange(value, 'principalPhone', 'mealSchoolInfo')}
                                                                    // todo: Need to use this {this.props.school.actionType === "NEW" ? 'US': ''} as we don't need default country for edit
                                                                    placeholder={`Mobile Number`}
                                                                    pattern="^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$"
                                                                    maxlength="15"
                                                                    smartCaret={false}
                                                                    displayInitialValueAsLocalNumber={true}
                                                                /> */}
                                                            <span id='message3'></span>
                                                        </div>
                                                    </div>
                                                    <div className="form-group clearfix">
                                                        <label className="col-md-4 control-label">Address:</label>
                                                        <div className="col-md-7">
                                                            <textarea id="fairHearingOfficialAddress" className="form-control"
                                                                rows="3" cols="60" name="fairHearingOfficialAddress" value={this.state.mealSchoolInfo.fairHearingOfficialAddress}
                                                                onChange={(e) => this.schoolInfo(e)}>
                                                            </textarea>
                                                            <span id='message4'></span>
                                                        </div>
                                                    </div>
                                                </div>
                                                : null}
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label"></label>
                                                    <div className="col-md-7">
                                                        <input type="button" className="btn btn-danger"
                                                            value="Cancel"
                                                            id="schoolInfoCancel" />
                                                        <Button type="submit" className="btn btn-success" id="submit">Update</Button>
                                                    </div>
                                                </div>
                                            </Form>
                                        </fieldset>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <div className="col-md-6 col-sm-12 col-xs-12">
                            <div className="panel panel-primary">
                                <div className="panel-heading text-center"><h3 className="panel-title">User Details</h3>
                                </div>
                                <div className="panel-body user-details-panel-body">
                                    <div className="form-group clearfix" id="changeNameUserOne">
                                        <label className="col-md-offset-1 col-md-3 control-label">Name :</label>
                                        <label className="col-md-5 control-label"><span
                                            id="userSpanFN">{this.state.userInfo.firstName}</span> <span
                                                id="userSpanLN">{this.state.userInfo.lastName}</span></label>
                                        <div className="col-md-2 text-center user-group-icon"><span
                                            className="bg-color-4 pull-right"
                                            onClick={editUserNameFun}><i
                                                className="fa fa-pencil-square-o" aria-hidden="true"></i></span></div>

                                    </div>
                                    <div className="form-group clearfix user-form-fieldset" id="changeNameUserTwo"
                                        style={{ display: 'none' }}>

                                        <fieldset className="user-fieldset">
                                            <form onSubmit={this.handleNameChange}>
                                                <legend>Change Name</legend>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">Last Name:</label>
                                                    <div className="col-md-7">
                                                        <input className="form-control"
                                                            type="text" id="userLN" name="lastName" />
                                                    </div>
                                                </div>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">First Name:</label>
                                                    <div className="col-md-7">
                                                        <input className="form-control"
                                                            type="text" id="userFN" name="firstName" />
                                                    </div>
                                                </div>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label"></label>
                                                    <div className="col-md-7">
                                                        <input type="button" className="btn btn-danger"
                                                            value="Cancel"
                                                            id="userNameUpdate" />
                                                        <input type="submit" className="btn btn-success"
                                                            value="Update" />
                                                    </div>
                                                </div>
                                            </form>
                                        </fieldset>

                                    </div>

                                    <div className="form-group clearfix" id="changePhoneOne">
                                        <label className=" col-md-offset-1 col-md-3 control-label">Phone :</label>
                                        <label className="col-md-5 control-label"><span
                                            id="userSpanPhone">{this.state.userInfo.mobileNo ? (dial_code() + this.state.userInfo.mobileNo) : 'Please Update Mobile Number'}</span></label>
                                        <div className="col-md-2 text-center user-group-icon"><span
                                            className="bg-color-4 pull-right"
                                            onClick={editPhoneFun}><i
                                                className="fa fa-pencil-square-o" aria-hidden="true"></i></span></div>

                                    </div>
                                    <div className="form-group clearfix user-form-fieldset" id="changePhoneTwo"
                                        style={{ display: 'none' }}>
                                        <fieldset className="user-fieldset">
                                            <form onSubmit={this.handlePhoneUpdate}>
                                                <legend>Change Contact Info</legend>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">Phone Number:</label>
                                                    <div className="col-md-7">
                                                        <input type="text"
                                                            className="form-control"
                                                            id="mobileNo"
                                                            name="mobileNo"
                                                            placeholder={'Mobile Number'}
                                                            onChange={e => this.handlePhoneChange(e, 'mobileNo', 'userInfo')}
                                                            value={this.state.userInfo.mobileNo}
                                                            maxLength={this.state.mobileLength}
                                                            onKeyPress={numberOnly} />
                                                        {/* <Phone
                                                            id="mobileNo"
                                                            className="form-control"
                                                            value={this.state.userInfo.mobileNo}
                                                            countries={['US', 'CA']}
                                                            onChange={value => this.handlePhoneChange(value, 'mobileNo', 'userInfo')}
                                                            // todo: Need to use this {this.props.school.actionType === "NEW" ? 'US': ''} as we don't need default country for edit
                                                            placeholder={`Mobile Number`}
                                                            pattern="^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$"
                                                            maxlength="15"
                                                            smartCaret={false}
                                                            displayInitialValueAsLocalNumber={true}
                                                            required/> */}
                                                    </div>
                                                </div>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label"></label>
                                                    <div className="col-md-7">
                                                        <input type="button" className="btn btn-danger"
                                                            value="Cancel"
                                                            id="PhoneUpdate" />
                                                        <input type="submit" className="btn btn-success"
                                                            value="Update" />
                                                    </div>
                                                </div>
                                            </form>
                                        </fieldset>

                                    </div>
                                    <div className="form-group clearfix" id="changeUNOne">
                                        <label className="col-md-offset-1 col-md-3 control-label">User Name
                                            :</label>
                                        <label className="col-md-5 control-label"><span
                                            id="userSpanUN">{this.state.userInfo.username}</span></label>
                                        {/*<div className="col-md-2 text-center user-group-icon"><span*/}
                                        {/*className="bg-color-4 pull-right"*/}
                                        {/*onClick={editUNFun}>*/}
                                        {/*/!*<i*!/*/}
                                        {/*/!*className="fa fa-pencil-square-o" aria-hidden="true"></i>*!/*/}

                                        {/*</span></div>*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">

                        <div className={this.state.mealSchoolInfo.isPaymentEnabled && this.state.mealSchoolInfo.stripeAccountId ? "col-md-6 col-sm-12 col-xs-12" : "col-md-8 col-md-offset-2 col-sm-12 col-xs-12"}>
                            <div className="panel panel-primary">
                                <div className="panel-heading text-center" id="changePassword"><h3
                                    className="panel-title">Login</h3></div>
                                <div className="panel-body login-details-panel-body">
                                    <div className="form-group clearfix">
                                        <div className="col-md-12 text-center">
                                            <button type="button"
                                                className="btn-social btn-twitter-link userChangePWD"
                                                onClick={changePWDFun}><span>Change Password</span></button>
                                        </div>
                                    </div>
                                    <div className="form-group clearfix user-form-fieldset" id="changePasswordSec"
                                        style={{ display: 'none' }}>

                                        <fieldset className="user-fieldset">
                                            <form onSubmit={(e) => this.changePassword(e)}>
                                                <legend>Change Password</legend>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">Old Password:</label>
                                                    <div className="col-md-7">
                                                        <input type="password" className="form-control" onKeyUp={this.checkPass}
                                                            name="opwd" id="opwd" placeholder="Old Password"
                                                            required />
                                                    </div>
                                                </div>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">New Password:</label>
                                                    <div className="col-md-7">
                                                        <input type="password" className="form-control"
                                                            name="pwd" id="pwd" placeholder="New Password"
                                                            onKeyUp={this.checkPass} onChange={(e) => this.onChange(e)}
                                                            required />
                                                    </div>
                                                </div>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">Confirm
                                                        Password:</label>
                                                    <div className="col-md-7">
                                                        <input type="password" className="form-control"
                                                            name="cpwd" id="cpwd"
                                                            placeholder="Confirm Password"
                                                            onKeyUp={this.checkPass} required />
                                                        <span id='message'></span>
                                                    </div>
                                                </div>
                                                <div className="form-group clearfix">
                                                    <div id="popover-password">
                                                        <p><span id="result"></span></p>
                                                        <div className="progress">
                                                            <div id="password-strength"
                                                                className="progress-bar"
                                                                role="progressbar"
                                                                aria-valuenow="40"
                                                                aria-valuemin="0"
                                                                aria-valuemax="100"
                                                                style={{ width: "0%" }}>
                                                            </div>
                                                        </div>
                                                        <ul className="list-unstyled">
                                                            <li className="">
                                                                <span className="low-upper-case">
                                                                    <i className="fa fa-circle" aria-hidden="true"></i>
                                                                    &nbsp;Lowercase &amp; Uppercase
                                                                </span>
                                                            </li>
                                                            <li className="">
                                                                <span className="one-number">
                                                                    <i className="fa fa-circle" aria-hidden="true"></i>
                                                                    &nbsp;Number (0-9)
                                                                </span>
                                                            </li>
                                                            <li className="">
                                                                <span className="one-special-char">
                                                                    <i className="fa fa-circle" aria-hidden="true"></i>
                                                                    &nbsp;Special Character (!@$%^&*)
                                                                </span>
                                                            </li>
                                                            <li className="">
                                                                <span className="eight-character">
                                                                    <i className="fa fa-circle" aria-hidden="true"></i>
                                                                    &nbsp;Atleast 8 Character
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label"></label>
                                                    <div className="col-md-7">
                                                        <button id="PwdUpdate" type='button' className="btn btn-danger" >Cancel</button>
                                                        <button type='submit' className="btn btn-success" id="pwdSubmit" disabled>Update</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </fieldset>
                                    </div>
                                    <div className="form-group clearfix">
                                        <div className="col-md-12 text-center">
                                            {/* <span>{this.state.userInfo.pin}</span> */}
                                            <button type="button" style={{ marginRight: "4%" }}
                                                className="btn-social btn-twitter-link userChangePIN"
                                                onClick={this.changePINFun}><span>Change Pin</span></button>
                                        </div>
                                    </div>

                                    <div className="form-group clearfix user-form-fieldset" id="changePinSec"
                                        style={{ display: 'none' }}>

                                        <fieldset className="user-fieldset">
                                            <form onSubmit={(e) => this.handlePinSubmit(e)}>
                                                <legend>Change Pin</legend>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">New Pin:</label>
                                                    <div className="col-md-7">
                                                        <input type="text" maxlength="4" className="form-control"
                                                            name="pin" id="pin" placeholder="New Pin"
                                                            onKeyUp={this.checkPin} onChange={(e) => this.onChangePin(e)} required />
                                                    </div>
                                                </div>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">Confirm
                                                        Pin:</label>
                                                    <div className="col-md-7">
                                                        <input type="text" maxlength="4" className="form-control"
                                                            name="cpin" id="cpin"
                                                            placeholder="Confirm Pin"
                                                            onKeyUp={this.checkPin} required />
                                                        <span id='pinMessage'></span>
                                                    </div>
                                                </div>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label"></label>
                                                    <div className="col-md-7">
                                                        <input type="button" className="btn btn-danger"
                                                            value="Cancel"
                                                            id="PinUpdate" />
                                                        <input className="btn btn-success" id="submitPin" type="submit"
                                                            /*  onClick={(e) => this.handlePinSubmit(e)} */
                                                            value="Update" />
                                                    </div>
                                                </div>
                                            </form>
                                        </fieldset>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.state.mealSchoolInfo.isPaymentEnabled && this.state.mealSchoolInfo.stripeAccountId ?
                            <div className="col-md-6 col-sm-12 col-xs-12">
                                <div className="panel panel-primary">
                                    <div className="panel-heading text-center"><h3 className="panel-title">Payment Gateway Details </h3>
                                    </div>
                                    <div className="panel-body">
                                        <div className='row'>
                                            <div className='col-md-2'>
                                                <label>A/C Id: </label>
                                            </div>
                                            <div className='col-md-5 text-right'>
                                                <label>{this.state.mealSchoolInfo.stripeAccountId}</label>
                                            </div>
                                            <div className='col-md-5 text-right'>
                                                <button className="btn btn-success" style={{ padding: '5px', margin: '0px' }} onClick={() => { this.gotoStripeDashboard() }}>
                                                    <i className="fa fa-tachometer" aria-hidden="true"></i> Payment Dashboard
                                                </button>
                                            </div>
                                        </div>

                                    </div>

                                </div></div> : null
                        }
                    </div>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className="panel panel-primary">
                                <div className="panel-body">
                                    <div className='row'>
                                        <div className='col-md-8'><label>Student registration URL: </label></div>
                                        <div className='col-md-4'>
                                            <a href="javascript:void(0);" title="Student Registration URL" onClick={() => {

                                                window.open(
                                                    `${window.origin}/studentRegistration`,
                                                    '_blank'
                                                );
                                            }}><i className="fa fa-external-link" style={{ fontSize: '25px' }} aria-hidden="true"></i></a>
                                            &nbsp; &nbsp;
                                            <a href="javascript:void(0);" title="Copy url to clipboard" onClick={() => {
                                                const url = `${window.origin}/studentRegistration`;
                                                window.navigator.clipboard.writeText(url).then(() => {
                                                    /* Resolved - text copied to clipboard */
                                                    _addNotification("Url copied to clipboard", this);
                                                }, () => {
                                                    /* Rejected - clipboard failed */
                                                });

                                            }}><i className="fa fa-clipboard" style={{ fontSize: '25px' }} aria-hidden="true"></i></a>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-8'>
                                            <label>Public menu URL: </label>
                                        </div>
                                        <div className='col-md-4'>
                                            <a href="javascript:void(0);" title="Student Registration URL" onClick={() => {

                                                window.open(
                                                    ENV == "Development" ? `${window.location.protocol}//devpublicmenu${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}/s/${window.location.host.substr(0, window.location.host.indexOf('.'))}` : ENV == "Production" ? `${window.location.protocol}//menus${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}/s/${window.location.host.substr(0, window.location.host.indexOf('.'))}` : `${window.location.protocol}//qapublicmenu${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}/s/${window.location.host.substr(0, window.location.host.indexOf('.'))}`,
                                                    '_blank'
                                                );
                                            }}><i className="fa fa-external-link" style={{ fontSize: '25px' }} aria-hidden="true"></i></a>
                                            &nbsp; &nbsp;
                                            <a href="javascript:void(0);" title="Copy url to clipboard" onClick={() => {
                                                const url = ENV == "Development" ? `${window.location.protocol}//devpublicmenu${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}/s/${window.location.host.substr(0, window.location.host.indexOf('.'))}` : ENV == "Production" ? `${window.location.protocol}//menus${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}/s/${window.location.host.substr(0, window.location.host.indexOf('.'))}` : `${window.location.protocol}//qapublicmenu${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}/s/${window.location.host.substr(0, window.location.host.indexOf('.'))}`
                                                window.navigator.clipboard.writeText(url).then(() => {
                                                    /* Resolved - text copied to clipboard */
                                                    _addNotification("Url copied to clipboard", this);
                                                }, () => {
                                                    /* Rejected - clipboard failed */
                                                });

                                            }}><i className="fa fa-clipboard" style={{ fontSize: '25px' }} aria-hidden="true"></i></a>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-md-8'>
                                            <label>Direct free/reduced application URL: </label>
                                        </div>
                                        <div className='col-md-4'>
                                            <a href="javascript:void(0);" title="Student Registration URL" onClick={() => {
                                                const url = ENV == "Development" ? `${window.location.protocol}//devapp${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}/free_reduced_program` : ENV == "Production" ? `${window.location.protocol}//app${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}/free_reduced_program` : `${window.location.protocol}//qaapp${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}/free_reduced_program`

                                                window.open(
                                                    url,
                                                    '_blank'
                                                );
                                            }}><i className="fa fa-external-link" style={{ fontSize: '25px' }} aria-hidden="true"></i></a>
                                            &nbsp; &nbsp;
                                            <a href="javascript:void(0);" title="Copy url to clipboard" onClick={() => {
                                                const url = ENV == "Development" ? `${window.location.protocol}//devapp${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}/free_reduced_program` : ENV == "Production" ? `${window.location.protocol}//app${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}/free_reduced_program` : `${window.location.protocol}//qaapp${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}/free_reduced_program`;
                                                window.navigator.clipboard.writeText(url).then(() => {
                                                    /* Resolved - text copied to clipboard */
                                                    _addNotification("Url copied to clipboard", this);
                                                }, () => {
                                                    /* Rejected - clipboard failed */
                                                });

                                            }}><i className="fa fa-clipboard" style={{ fontSize: '25px' }} aria-hidden="true"></i></a>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-8'>
                                            <label>Parent login URL: </label>
                                        </div>
                                        <div className='col-md-4'>
                                            <a href="javascript:void(0);" title="Student Registration URL" onClick={() => {
                                                const url = ENV == "Development" ? `${window.location.protocol}//devapp${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}/${window.location.host.substr(0, window.location.host.indexOf('.'))}/parent` : ENV == "Production" ? `${window.location.protocol}//app${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}/${window.location.host.substr(0, window.location.host.indexOf('.'))}/parent` : `${window.location.protocol}//qaapp${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}/${window.location.host.substr(0, window.location.host.indexOf('.'))}/parent`;

                                                window.open(
                                                    url,
                                                    '_blank'
                                                );
                                            }}><i className="fa fa-external-link" style={{ fontSize: '25px' }} aria-hidden="true"></i></a>
                                            &nbsp; &nbsp;
                                            <a href="javascript:void(0);" title="Copy url to clipboard" onClick={() => {
                                                const url = ENV == "Development" ? `${window.location.protocol}//devapp${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}/${window.location.host.substr(0, window.location.host.indexOf('.'))}/parent` : ENV == "Production" ? `${window.location.protocol}//app${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}/${window.location.host.substr(0, window.location.host.indexOf('.'))}/parent` : `${window.location.protocol}//qaapp${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}/${window.location.host.substr(0, window.location.host.indexOf('.'))}/parent`;
                                                window.navigator.clipboard.writeText(url).then(() => {
                                                    /* Resolved - text copied to clipboard */
                                                    _addNotification("Url copied to clipboard", this);
                                                }, () => {
                                                    /* Rejected - clipboard failed */
                                                });

                                            }}><i className="fa fa-clipboard" style={{ fontSize: '25px' }} aria-hidden="true"></i></a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        );
    }

}

accountDetails.contextTypes = {
    router: PropTypes.object.isRequired
}


export default accountDetails;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Account/accountDetails.js